import { t } from 'i18n';
import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from '@teko/ui';
import { Logo, LogoProps } from '@teko/ecommerce';
import { useGlobalData } from 'contexts';
import { useTenantConfig } from 'hooks';
import { MegaMenu } from '@teko/teko-ecommerce';
import { MegaMenuItemInterface } from '@teko/types/pb';
import { styled, CustomLink, ThemeProps } from '@teko/ds-desktop';
import { MenuOutlined } from '@teko/ds-icon';
import { getTrackingData } from '@teko/tracking';

interface LogoHeaderProps {
  isLite: boolean;
  dropdownOpen: boolean;
  toggle: () => void;
  menuItems?: MegaMenuItemInterface[];
}

interface StyledLogoProps extends LogoProps {
  lite: boolean;
}

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledLogo = styled(Logo)(
  ({ lite }: StyledLogoProps) => `
  ${lite ? 'margin-right: 1rem; margin-left: 0.4rem;' : ''};
  -webkit-transition: all .15s ease-in-out;
  -moz-transition: all .15s ease-in-out;
  transition: all .15s ease-in-out;
`,
);
const MenuButton = styled.div(
  ({ theme }: ThemeProps) => `
border: 1px solid #e0e0e0;
cursor: pointer;
border-radius: 4px;
line-height: 1rem;
padding: 0.4rem 0.75rem;
text-align: center;
color: ${theme?.colors.textSecondary};
&:hover{
  background: rgb(245, 245, 245);
}
`,
);
const StyledDropdownMenu = styled(DropdownMenu)`
  transform: translate(16px, 72px) !important;
`;
const MegaMenuWrapper = styled.div`
  width: 204px;
  border-radius: 0.5rem;
`;

const DummyLink = styled.a`
  margin-left: 0.4rem;
  color: inherit;
  text-decoration: inherit;
  :hover {
    color: inherit;
  }
`;

export const LogoHeader: React.FC<LogoHeaderProps> = ({
  isLite,
  dropdownOpen,
  toggle,
  menuItems,
}: LogoHeaderProps) => {
  const globalData = useGlobalData();
  const { logo } = useTenantConfig();
  return (
    <LogoWrapper
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'logoPhongVu',
        target: 'homepage',
      })}
    >
      <CustomLink href="/">
        <StyledLogo
          variant={isLite ? 'square' : 'full'}
          lite={isLite}
          width={
            logo[isLite ? 'lite' : 'full'].width
              ? `${logo[isLite ? 'lite' : 'full'].width}px`
              : 'auto'
          }
          height={`${logo[isLite ? 'lite' : 'full'].height || 35}px`}
          alt={globalData.tenant}
          logoFull={logo.full.path}
          logoLite={logo.lite.path || logo.full.path}
        />
      </CustomLink>
      {isLite && !!menuItems?.length && (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle>
            <MenuButton>
              <MenuOutlined size={20} color="textSecondary" />
              <DummyLink
                onClick={(evt) => {
                  // the purpose of this link
                  // is to let Google crawler to follow to the categories listing.
                  // we prevent users from actually clicking here.
                  evt.preventDefault();
                  return false;
                }}
                href="/categories"
              >
                {t('Danh mục sản phẩm')}
              </DummyLink>
            </MenuButton>
          </DropdownToggle>
          <StyledDropdownMenu>
            <MegaMenuWrapper>
              <MegaMenu menuItems={menuItems} type="vertical" />
            </MegaMenuWrapper>
          </StyledDropdownMenu>
        </Dropdown>
      )}
    </LogoWrapper>
  );
};
